import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import { useGetPhoneSystemNumbersQuery } from 'src/generated/graphql'

export const IncomingCallPhoneSystemDisplay = ({ node, flow }) => {
  const getPhoneSystemNumbersQuery = useGetPhoneSystemNumbersQuery({
    variables: {
      phoneSystemId: flow.phoneSystemId,
    },
  })

  const number = getPhoneSystemNumbersQuery.data?.phoneSystemNumbers.find(
    item => item.id === node.extras.numberSid
  )

  return (
    <div>
      <SimpleTable>
        <div>
          <div>Phone:</div>
          <div>{number?.number}</div>
        </div>
      </SimpleTable>
      {getPhoneSystemNumbersQuery.loading && <LoadingOverlay />}
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/Flows/Flow/Nodes/IncomingCall/IncomingCallPhoneSystemDisplay.tsx